import src from "IMAGE";
export default { src, width: 352, height: 352, blurWidth: 0, blurHeight: 0};
